module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-toggle is-centered"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "to": "/hour",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Hour")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/day",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Day")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/week",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Week")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/month",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Month")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/year",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Year")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-415bd71a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TemperatureRanges.vue
// module id = 373
// module chunks = 1